import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'ReWriteCardStore',
  namespaced: true,
  stateFactory: true
})
export default class ReWriteCardStore extends BaseStore {
  // リライトカード処理中かの判定
  _processing: boolean = false

  // 読み込んだ利用者番号
  _loadedUserNo: string | undefined = undefined

  // リーダライタ装置の読み込み待ち状態判定
  _readPending: boolean = false

  // リーダライタ装置の電源判定
  _power: boolean = true

  get processing(): boolean {
    return this._processing
  }

  get loaded(): boolean {
    return this._loadedUserNo !== undefined
  }

  get registered(): boolean {
    return this.loaded && this._loadedUserNo !== ''
  }

  get loadedUserNo(): string | undefined {
    return this._loadedUserNo
  }

  get readPending(): boolean {
    return this._readPending
  }

  get power(): boolean {
    return this._power
  }

  // 非同期存在しないのでpublicとmutation組み合わせた処理で済ませておく
  @Mutation
  public startProcess(): void {
    this._processing = true
  }

  @Mutation
  public endProcess(): void {
    this._processing = false
  }

  @Mutation
  public loadUserNo(userNo: string): void {
    this._loadedUserNo = userNo
  }

  @Mutation
  public unLoadUserNo(): void {
    this._loadedUserNo = undefined
  }

  @Mutation
  public startReadPending(): void {
    this._readPending = true
  }

  @Mutation
  public endReadPending(): void {
    this._readPending = false
  }

  @Mutation
  public powerOn(): void {
    this._power = true
  }

  @Mutation
  public powerOff(): void {
    this._power = false

    // 電源が落ちたと判明した時点で全てのデータを初期化する
    // 理由としては、リーダライタ装置の仕様として電源を上げた時にカード自体を排出している為、画面側の状態保持も初期化する必要がある
    this._processing = false
    this._loadedUserNo = undefined
    this._readPending = false
  }
}
